<script setup lang="ts">
  import { ref } from 'vue';

  const selectedTab = ref(0);

  const quickLinks = [
    /*{
      icon: 'mdi-book-open-variant',
      title: 'Guía de inicio',
      description: 'Aprende a configurar tu tienda',
      url: 'https://queresto.com/docs/getting-started',
    },*/
    {
      icon: 'mdi-lifebuoy',
      title: 'Soporte',
      description: 'Contáctenos para recibir ayuda',
      url: 'mailto:info@queresto.com',
    },
    /*{
      icon: 'mdi-telegram',
      title: 'Comunidad Telegram',
      description: 'Únete a nuestra comunidad',
      url: 'https://t.me/queresto',
    },*/
  ];

  const features = [
    {
      icon: 'mdi-qrcode',
      title: 'Código QR',
      description: 'Genere QR personalizados para su menú',
    },
    {
      icon: 'mdi-whatsapp',
      title: 'Pedidos WhatsApp',
      description: 'Reciba pedidos directamente en WhatsApp',
    },
    {
      icon: 'mdi-cash-register',
      title: 'Punto de Venta',
      description: 'Sistema POS integrado para su negocio',
    },
  ];
</script>

<template>
  <v-card class="resources-card">
    <v-tabs
      v-model="selectedTab"
      background-color="transparent"
      color="primary"
      grow
    >
      <v-tab>
        <v-icon left small>mdi-school</v-icon>
        Tutorial
      </v-tab>
      <v-tab>
        <v-icon left small>mdi-link</v-icon>
        Enlaces
      </v-tab>
      <v-tab>
        <v-icon left small>mdi-star</v-icon>
        Características
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab">
      <!-- Tutorial Tab -->
      <v-tab-item>
        <v-card-text>
          <h4 class="tab-title">{{ $t('dashboard.tutorial') }}</h4>
          <div class="video-wrapper">
            <iframe
              width="100%"
              height="auto"
              src="https://www.youtube.com/embed/MiyQ_-Kj5LE?start=21"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <p class="video-description">
            Aprenda a configurar su tienda digital en menos de 5 minutos
          </p>
        </v-card-text>
      </v-tab-item>

      <!-- Quick Links Tab -->
      <v-tab-item>
        <v-card-text>
          <h4 class="tab-title">Enlaces rápidos</h4>
          <div class="links-list">
            <a
              v-for="link in quickLinks"
              :key="link.title"
              :href="link.url"
              target="_blank"
              class="link-item"
            >
              <v-icon class="link-icon">{{ link.icon }}</v-icon>
              <div class="link-content">
                <span class="link-title">{{ link.title }}</span>
                <span class="link-description">{{ link.description }}</span>
              </div>
              <v-icon class="link-arrow">mdi-chevron-right</v-icon>
            </a>
          </div>
        </v-card-text>
      </v-tab-item>

      <!-- Features Tab -->
      <v-tab-item>
        <v-card-text>
          <h4 class="tab-title">Características principales</h4>
          <div class="features-list">
            <div
              v-for="feature in features"
              :key="feature.title"
              class="feature-item"
            >
              <v-icon class="feature-icon" color="primary">{{
                feature.icon
              }}</v-icon>
              <div class="feature-content">
                <span class="feature-title">{{ feature.title }}</span>
                <span class="feature-description">{{
                  feature.description
                }}</span>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<style scoped lang="scss">
  .resources-card {
    @apply tw-rounded-2xl tw-shadow-sm #{!important}; // DO NOT FIX THIS LINTER ERROR

    .tab-title {
      @apply tw-text-lg tw-font-medium tw-text-neutral-800 tw-mb-4;
    }

    .video-wrapper {
      @apply tw-relative tw-w-full;
      @apply tw-rounded-lg tw-overflow-hidden tw-mb-3;
      padding-bottom: 56.25%; // 16:9 aspect ratio

      iframe {
        @apply tw-absolute tw-top-0 tw-left-0;
        @apply tw-w-full tw-h-full;
      }
    }

    .video-description {
      @apply tw-text-sm tw-text-neutral-600 tw-text-center;
    }

    .links-list {
      @apply tw-space-y-2;

      .link-item {
        @apply tw-flex tw-items-center tw-gap-3;
        @apply tw-p-3 tw-rounded-lg;
        @apply tw-bg-neutral-50 tw-transition-all tw-duration-200;
        @apply hover:tw-bg-neutral-100 hover:tw-shadow-sm;
        @apply tw-no-underline;

        .link-icon {
          @apply tw-text-neutral-600;
        }

        .link-content {
          @apply tw-flex-1 tw-flex tw-flex-col;

          .link-title {
            @apply tw-text-neutral-800 tw-font-medium;
          }

          .link-description {
            @apply tw-text-sm tw-text-neutral-500;
          }
        }

        .link-arrow {
          @apply tw-text-neutral-400;
        }
      }
    }

    .features-list {
      @apply tw-space-y-3;

      .feature-item {
        @apply tw-flex tw-items-start tw-gap-3;

        .feature-icon {
          @apply tw-mt-1;
        }

        .feature-content {
          @apply tw-flex tw-flex-col;

          .feature-title {
            @apply tw-font-medium tw-text-neutral-800;
          }

          .feature-description {
            @apply tw-text-sm tw-text-neutral-600;
          }
        }
      }
    }
  }
</style>
